if (!customElements.get('salon-stock-availability')) {
  customElements.define(
    'salon-stock-availability',
    class SalonStockAvailability extends HTMLElement {
      connectedCallback() {
        this.endpoint = this.dataset.endpoint;
        this.sectionId = this.dataset.sectionId;
        this.label = this.querySelector('[data-salon-stock-label]');
        this.detail = this.querySelector('[data-salon-stock-detail]');
        this.productForm = document.getElementById(
          `product-form-${this.sectionId}`
        );
        this.variantInput = this.productForm?.querySelector('[name="id"]');
        this.onVariantChange = this.handleVariantChange.bind(this);
        this.variantInput?.addEventListener('change', this.onVariantChange);
        this.fetchAvailability(
          this.variantInput?.value || this.dataset.variantId
        );
      }

      disconnectedCallback() {
        this.variantInput?.removeEventListener('change', this.onVariantChange);
        this.abortController?.abort();
      }

      handleVariantChange(event) {
        this.fetchAvailability(event.target.value);
      }

      async fetchAvailability(variantId) {
        if (!this.endpoint || !variantId) {
          this.hide();
          return;
        }

        this.abortController?.abort();
        this.abortController = new AbortController();
        this.hide();

        try {
          const url = new URL(this.endpoint, window.location.origin);
          url.searchParams.set('variant_id', variantId);
          const response = await fetch(url, {
            headers: { Accept: 'application/json' },
            signal: this.abortController.signal,
          });

          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const result = await response.json();
          this.render(result);
        } catch (error) {
          if (error.name !== 'AbortError') this.hide();
        }
      }

      render(result) {
        const visibleStatuses = ['in_stock', 'low_stock', 'out_of_stock'];
        if (!visibleStatuses.includes(result.status)) {
          this.hide();
          return;
        }

        const details = {
          in_stock: 'Walk-in purchase only. Please call ahead to confirm.',
          low_stock: 'Walk-in purchase only. Please call ahead to confirm.',
          out_of_stock:
            'Salon shelf stock is separate from online Pick Up In Store orders.',
        };

        this.dataset.status = result.status;
        this.label.textContent = `HAIR PLUS SALON: ${result.label}`;
        this.detail.textContent = details[result.status];
        this.hidden = false;
      }

      hide() {
        this.hidden = true;
        delete this.dataset.status;
      }
    }
  );
}
